import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import { puede } from "../../../../permisos/permisos";

function ConfigPlasticos() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_MOLDES = process.env.REACT_APP_URL_MOLDES_INYECCION;
  const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [tab, setTab] = useState("articulos");
  const [articulos, setArticulos] = useState([]);
  const [telas, setTelas] = useState([]);
  const [moldes, setMoldes] = useState([]);

  // Modal articulo
  const [modalArt, setModalArt] = useState(false);
  const [idArt, setIdArt] = useState(null);
  const [descArt, setDescArt] = useState("");
  const [tipoArt, setTipoArt] = useState("Fabricacion");
  const [cavidades, setCavidades] = useState(1);
  const [minArt, setMinArt] = useState(0);
  const [moldeArt, setMoldeArt] = useState("");

  // Modal tela/resina
  const [modalTela, setModalTela] = useState(false);
  const [idTela, setIdTela] = useState(null);
  const [nombreTela, setNombreTela] = useState("");
  const [minTela, setMinTela] = useState(0);

  useEffect(() => {
    axios.get(URL_ARTICULOS, headers).then((r) => setArticulos(r.data)).catch((e) => console.log(e));
    axios.get(URL_TELAS, headers).then((r) => setTelas(r.data)).catch((e) => console.log(e));
    axios.get(URL_MOLDES, headers).then((r) => setMoldes(r.data)).catch((e) => console.log(e));
  }, []);

  function abreArt(a) {
    setIdArt(a._id); setDescArt(a.descripcion);
    setTipoArt(a.tipo_articulo || "Fabricacion"); setCavidades(a.cavidades || 1);
    setMinArt(a.minimo || 0); setMoldeArt(a.moldeInyeccion && a.moldeInyeccion[0] ? (a.moldeInyeccion[0]._id || a.moldeInyeccion[0]) : "");
    setModalArt(true);
  }
  function guardaArt() {
    const body = { tipo_articulo: tipoArt, cavidades: Number(cavidades), minimo: Number(minArt) };
    body.moldeInyeccion = moldeArt ? [moldeArt] : [];
    axios.patch(`${URL_ARTICULOS}/${idArt}`, body, headers)
      .then(() => { setModalArt(false); Swal.fire("Good job!", "Artículo actualizado", "success"); window.location.reload(); })
      .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? JSON.stringify(error.response.data) : error}` }));
  }

  function abreTela(t) {
    setIdTela(t._id); setNombreTela(t.nombre); setMinTela(t.minimo || 0); setModalTela(true);
  }
  function guardaTela() {
    axios.patch(`${URL_TELAS}/${idTela}`, { minimo: Number(minTela) }, headers)
      .then(() => { setModalTela(false); Swal.fire("Good job!", "Materia prima actualizada", "success"); window.location.reload(); })
      .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? JSON.stringify(error.response.data) : error}` }));
  }

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puede(user, "produccion.produccion.ver") ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-sliders-h" style={{ marginRight: 8, color: "#8b5cf6" }} />
                  Config Plásticos
                </h3>
                <p className="page-subtitle">Bandera/cavidades/mínimos por artículo y mínimos de materia prima</p>
              </div>
            </div>

            <Nav tabs>
              <NavItem>
                <NavLink href="#" active={tab === "articulos"} onClick={() => setTab("articulos")}>
                  Artículos (botellas)
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#" active={tab === "resina"} onClick={() => setTab("resina")}>
                  Materia Prima
                </NavLink>
              </NavItem>
            </Nav>
            <br />

            {tab === "articulos" ? (
              <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
                <thead>
                  <tr>
                    <th className="tituloTabla">Artículo</th>
                    <th className="tituloTabla">Tipo</th>
                    <th className="tituloTabla">Cavidades</th>
                    <th className="tituloTabla">Mínimo</th>
                    <th className="tituloTabla">Molde Iny.</th>
                    <th className="tituloTabla">Editar</th>
                  </tr>
                </thead>
                <tbody>
                  {articulos.map((a) => (
                    <tr key={a._id}>
                      <td>{a.descripcion}</td>
                      <td>
                        <span className={`badge badge-${(a.tipo_articulo || "Fabricacion") === "Comercial" ? "info" : "primary"}`}>
                          {a.tipo_articulo || "Fabricacion"}
                        </span>
                      </td>
                      <td>{a.cavidades || 1}</td>
                      <td>{a.minimo || 0}</td>
                      <td>{a.moldeInyeccion && a.moldeInyeccion[0] ? (a.moldeInyeccion[0].nombre || "-") : "-"}</td>
                      <td>
                        <Button color="info" size="sm" onClick={() => abreArt(a)}>
                          <i className="far fa-edit"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
                <thead>
                  <tr>
                    <th className="tituloTabla">Material</th>
                    <th className="tituloTabla">Mínimo inventario</th>
                    <th className="tituloTabla">Editar</th>
                  </tr>
                </thead>
                <tbody>
                  {telas.map((t) => (
                    <tr key={t._id}>
                      <td>{t.nombre}</td>
                      <td>{t.minimo || 0}</td>
                      <td>
                        <Button color="info" size="sm" onClick={() => abreTela(t)}>
                          <i className="far fa-edit"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        ) : undefined}
      </div>

      {/* Modal articulo */}
      <Modal size="md" isOpen={modalArt} toggle={() => setModalArt(false)}>
        <ModalHeader toggle={() => setModalArt(false)}>Configurar: {descArt}</ModalHeader>
        <ModalBody>
          <Label>Tipo de artículo</Label>
          <Input type="select" value={tipoArt} onChange={(e) => setTipoArt(e.target.value)}>
            <option value="Fabricacion">Fabricación (se produce)</option>
            <option value="Comercial">Comercializacion (se compra/revende)</option>
          </Input>
          <br />
          <Row>
            <Col md={6}>
              <Label>Cavidades (soplado)</Label>
              <Input type="number" value={cavidades} onChange={(e) => setCavidades(e.target.value)} />
            </Col>
            <Col md={6}>
              <Label>Mínimo inventario</Label>
              <Input type="number" value={minArt} onChange={(e) => setMinArt(e.target.value)} />
            </Col>
          </Row>
          <br />
          {tipoArt === "Fabricacion" && (
            <>
              <Label>Molde de Inyección</Label>
              <Input type="select" value={moldeArt} onChange={(e) => setMoldeArt(e.target.value)}>
                <option value="">Sin asignar</option>
                {moldes.map((m) => <option key={m._id} value={m._id}>{m.nombre}</option>)}
              </Input>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardaArt}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal resina */}
      <Modal size="sm" isOpen={modalTela} toggle={() => setModalTela(false)}>
        <ModalHeader toggle={() => setModalTela(false)}>Mínimo: {nombreTela}</ModalHeader>
        <ModalBody>
          <Label>Mínimo de inventario</Label>
          <Input type="number" value={minTela} onChange={(e) => setMinTela(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardaTela}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ConfigPlasticos;
